export * from './consent-storage-adapter';
